// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3zOU-","label":"Category_label__Q46I2","content":"Category_content__1QxUF","header":"Category_header__9QM83","location":"Category_location__3u7Ca"};